import { render, staticRenderFns } from "./OrthoSplint.vue?vue&type=template&id=68abba3d&scoped=true"
import script from "./OrthoSplint.vue?vue&type=script&lang=js"
export * from "./OrthoSplint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68abba3d",
  null
  
)

export default component.exports